import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

export type DropdownMenuSubProps = DropdownMenuPrimitive.DropdownMenuSubProps;

export const DropdownMenuSub = DropdownMenuPrimitive.Sub;
